import { AxiosError } from 'axios';
import { AssignProductsToDosageDiaryProps } from '../interface/interface';
import instance from '../config/axios';

export async function assignProductToDosageDiary(
  token: string,
  props: AssignProductsToDosageDiaryProps,
) {
  try {
    const result = await instance({
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      url: '/api/v1/dosasgedairy/profile/assign',
      data: {
        profileId: props.profileId,
        products: props.productList,
      },
    });

    return result.status;
  } catch (e) {
    console.log(e);
    return ((e as AxiosError).response!.data as { message: string }).message;
  }
}
